import React, { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Button } from "reactstrap";
import DatePicker from "react-flatpickr";

export default function Revenue() {
  // const [estimatedRevenue, setEstimatedRevenue] = useState([]);
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());

  const getEstimatedRevenueIL = useCallback(async () => {
    const finalSettlementValues = await axios.get(
      "/revenue/estimatedRevenue?startDate=" + startDate + "&endDate=" + endDate
    );

    if (finalSettlementValues.status === 200) {
      console.log(finalSettlementValues, "finalSettlementValues");
    }
  }, [startDate, endDate]);

  function handleGetEstimatedReturn() {
    getEstimatedRevenueIL();
  }

  useEffect(() => {
    getEstimatedRevenueIL();
  }, [getEstimatedRevenueIL]);

  return (
    <div>
      <DatePicker
        dateFormat="DD/MM/yyyy"
        selected={startDate}
        onChange={(date) => setStartDate(date)}
        value={startDate}
      />
      <DatePicker
        dateFormat="DD/MM/yyyy"
        selected={endDate}
        onChange={(date) => setEndDate(date)}
        value={endDate}
      />
      <Button onClick={handleGetEstimatedReturn}>Get Estimated Returns</Button>
    </div>
  );
}
